export const logDelay = (i: number) => ({
  style: { animationDelay: `${Math.log(i + 1) / 15}s` }
});
